import { Alert, Button, Form, Input, InputNumber, Select } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import * as React from 'react'
import { useEffect, useState } from 'react'
import ReactJWPlayer from 'react-jw-player'
import { useHistory } from 'react-router'
import { HouseCreativeBean, PublisherBean } from 'src/api/api'
import { customFetch } from 'src/api/customFetch'
import { env } from 'src/env'
import { formDataLoader, FormDataType } from 'src/util/FormDataLoader'
import prebidRequest from './prebidRequest.json'

const FormItem = Form.Item
const Option = Select.Option
const FormatEnum = HouseCreativeBean.FormatEnum

interface Props {

}

const formInfoItems: FormDataType[] = [
    FormDataType.Publishers
]

const TestRequest: React.FC<Props> = () => {

    const [form] = useForm()
    const [error, setError] = useState()
    const [loading, setLoading] = useState(Boolean)
    const [adCode, setAdCode] = useState(String)
    const [format, setFormat] = useState<any>()
    const [vastUrl, setVastUrl] = useState(String)

    const history = useHistory()

    const [width, setWidth] = useState<any>()
    const [height, setHeight] = useState<any>()

    const [info, setInfo] = useState({
        publishers: []
    })

    const handleSubmit = () => {
        setLoading(true)
        form.validateFields().then(values => sendBidRequest(values))
    }

    const sendBidRequest = async (values) => {
        try {
            const requestURL = env.exchange + '/bid?prebid=true'
            const requestData = prebidRequest

            requestData.signRequest.bids.forEach(bid => {
                bid.token = values['publisherToken']
                bid.width = width
                bid.height = height
                bid.impMediaType = format
            })

            const response = await customFetch(requestURL,
                {
                    method: 'POST',
                    body: JSON.stringify(requestData),
                    headers: { 'Rtb-Direct': 'true' }
                }
            )

            let code: string | undefined
            if (response.status == 200) {
                const json = await response.json()
                const { prebidResponse } = json
                code = prebidResponse[0].ad
            }

            setAdCode(code || '')
            setLoading(false)
        } catch (e) {
            setError(e.error)
        }
    }

    const loadFormData = async () => {
        try {
            let formInfo = await formDataLoader(...formInfoItems)
            setInfo(formInfo as any)
        } catch (e) {
            setError(e.error)
        }
    }

    useEffect(() => {
        loadFormData()
    }, [])

    useEffect(() => {
        if ((FormatEnum.Video == format) && adCode) {
            customFetch('https://prebid.adnxs.com/pbc/v1/cache', {
                method: 'POST',
                body: JSON.stringify({ puts: [{ timestamp: Date.now(), ttlseconds: 300, type: 'xml', value: adCode }] }),
            }).then(response => {
                response.json().then(json => {
                    let url = 'https://prebid.adnxs.com/pbc/v1/cache?uuid=' + json.responses[0].uuid
                    setVastUrl(url)
                })
            })
        }
    }, [format, adCode])

    const resetAdCode = e => setAdCode('')

    const renderPreview = (): any => {
        if (format == FormatEnum.Banner) return renderIFramePreview()
        if (format == FormatEnum.Video && vastUrl) return renderVastPreview()
    }

    const renderIFramePreview = () => {
        return <iframe
            width={width}
            height={height}
            frameBorder={0}
            srcDoc={adCode}
        />
    }

    const renderVastPreview = () => {
        let newScheduleArray = [
            {
                tag: [vastUrl],
                type: 'linear'
            }
        ]

        const ads = {
            admessage: 'This video will resume in xx seconds',
            adscheduleid: 'adscheduledid',
            client: 'vast',
            cuetext: 'Advertisement',
            outstream: false,
            preloadAds: false,
            vpaidcontrols: true,
            rules: {
                startOnSeek: 'pre',
                timeBetweenAds: 0
            },
            schedule: newScheduleArray
        }

        return <ReactJWPlayer
            file="https://cdn.visualidx.com/media/video/one_second_blank.m4v"
            playerId="42"
            playerScript="https://cdn.jwplayer.com/libraries/cDnha7c4.js"
            customProps={{ advertising: { ...ads } }}
        />
    }

    return (
        <Form
            style={{
                maxWidth: '1000px'
            }}
            onFinish={handleSubmit}
            form={form}
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 19 }}
        >
            {error ? <Alert message={error} type="error" /> : null}
            <FormItem
                label="URL"
            >
                <Input value={env.exchange + '/bid?prebid=true'} />
            </FormItem>
            <FormItem
                name="publisherToken"
                label="Publisher"
                rules={[
                    {
                        required: true,
                        message: 'Please select publisher'
                    }
                ]}
            >
                <Select onChange={resetAdCode}>
                    {info.publishers.map((pub: PublisherBean) => (<Option title={pub.name} key={pub.id} value={pub.token}>{pub.name}</Option>))}
                </Select>
            </FormItem>
            <FormItem
                name="format"
                label="Format"
                rules={[
                    {
                        required: true,
                        message: 'Please select format'
                    }
                ]}
            >
                <Select onChange={e => {
                    setFormat(e)
                    resetAdCode(e)
                }}>
                    {[FormatEnum.Banner, FormatEnum.Video].map((f) => (<Option title={f} key={f} value={f}>{f}</Option>))}
                </Select>
            </FormItem>
            <FormItem
                required
                label="Size"
            >
                <FormItem
                    name="width"
                    className="ant-item ant-item-first"
                    rules={[
                        {
                            required: true,
                            message: 'Please input width'
                        }
                    ]}
                >
                    <InputNumber min={1} max={10000} placeholder="Width" onChange={e => {
                        setWidth(e)
                        resetAdCode(e)
                    }} />
                </FormItem>
                <FormItem
                    name="height"
                    className="ant-item ant-item-second"
                    rules={[
                        {
                            required: true,
                            message: 'Please input height'
                        }
                    ]}
                >
                    <InputNumber min={1} max={10000} placeholder="Height" onChange={e => {
                        setHeight(e)
                        resetAdCode(e)
                    }} />
                </FormItem>
            </FormItem>
            <FormItem
                label="Preview"
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 19 }}
            >
                {adCode ? renderPreview() : 'No Data'}
            </FormItem>
            <FormItem
                wrapperCol={{
                    offset: 11, span: 6
                }}>
                <Button style={{
                    width: '45%',
                    margin: '0 2%'
                }} type="primary" htmlType="submit" loading={loading}>Send Request</Button>
                <Button style={{
                    width: '45%',
                    margin: '0 2%'
                }} type="primary" danger htmlType="button" onClick={history.goBack}>Back</Button>
            </FormItem>
        </Form>
    );
}

export default TestRequest;
